const HEADER_HEIGHT = 90;

/**
 * Прокручивает контейнер меню так, чтобы активный пункт меню был в центре видимой области.
 */
function scrollToActiveLink() {
  const activeLink = document.querySelector(".how-to-menu__links a.active");
  const container = document.querySelector(".how-to-menu__links");

  if (activeLink && container) {
    const containerRect = container.getBoundingClientRect();
    const linkRect = activeLink.getBoundingClientRect();

    const offsetTop = linkRect.top - containerRect.top + container.scrollTop;

    const middleOfContainer = container.scrollTop + container.clientHeight / 2;
    const shouldScroll = Math.abs(offsetTop - middleOfContainer) > 50;

    if (shouldScroll) {
      container.scrollTo({
        top: offsetTop - container.clientHeight / 2 + linkRect.height / 2,
        behavior: "smooth",
      });
    }
  }
}

/**
 * Инициализирует плавающее меню и отслеживание активной секции при скролле.
 * Работает только на десктопе. Меню фиксируется при прокрутке.
 */
function initMenuAndScroll() {
  const navLinks = Array.from(document.querySelectorAll(".how-to-menu__links a"));
  const sections = document.querySelectorAll(".how-to-content");
  let currentLink;

  const sideMenuObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const id = entry?.target?.id;

      if (entry.isIntersecting) {
        const entryLink = navLinks.find(l => l.hash === `#${id}`);

        if (currentLink !== entryLink) {
          currentLink?.classList?.remove("active");
          currentLink = entryLink;
          currentLink.classList.add("active");
          scrollToActiveLink();
        }
      }
    });
  }, {
    rootMargin: "-75px 0% -70% 0%",
    threshhold: 1,
  });

  sections.forEach(section => sideMenuObserver.observe(section));

  // Обработка кликов по якорным ссылкам
  const anchors = document.querySelectorAll(".how-to-menu__links a[href^=\"#\"]");

  anchors.forEach((anchor) => {
    anchor.addEventListener("click", (e) => {
      e.preventDefault();

      const targetId = anchor.getAttribute("href");
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        const offsetTop = targetElement.offsetTop - HEADER_HEIGHT;

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }
    });
  });
}

export default initMenuAndScroll;
